import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CouponCodeService {

  constructor(private readonly _http: HttpClient) { }

    getCouponCode() {
      return this._http.get<any>(`${environment.apiUrl}/CouponCode/Get`);
    }
    updateCouponCode(data: any) {
      return this._http.post(`${environment.apiUrl}/CouponCode/Update`, data);
    }
    AddCouponCode(data: any) {
      return this._http.post(`${environment.apiUrl}/CouponCode/Create`, data);
    }
    UpdateCouponStatus(id: any, status: boolean) {
    return this._http.put(`${environment.apiUrl}/CouponCode/UpdateCouponStatus?id=${id}&status=${status}`, null);
  }
}
